// Punta Tech — all page copy in one place.
//
// PLACEHOLDER CONTENT: everything in LOGO_CLIENTS, CERTS, CASES and QUOTES, plus the
// "Javier Moreno" founder card in LeadForm, comes from the original design mockup and is
// NOT verified fact. Replace with real client names, certifications, case studies and
// testimonials before relying on this copy in a sales conversation. See README.md.

export const SERVICES = [
  [
    "AI & LLM Engineering",
    "We design and deploy production-grade AI systems — RAG pipelines, agentic workflows, MCP integrations, and LLM solutions using Claude, OpenAI, and open-source models.",
  ],
  [
    "MLOps & Model Lifecycle",
    "We operationalize machine learning: automated deployment pipelines, model evaluation, drift monitoring, and CI/CD for ML systems across AWS, Azure, and GCP.",
  ],
  [
    "Data Engineering",
    "We build scalable, reliable data infrastructure on Databricks, Apache Spark, and dbt — including Delta Lake architecture, Unity Catalog, and real-time streaming pipelines.",
  ],
  [
    "Cloud Infrastructure & IaC",
    "We architect and manage multi-cloud environments on AWS, Azure, and GCP using Terraform, Kubernetes, Docker, OpenShift, and ROSA.",
  ],
  [
    "Document AI & Process Automation",
    "We automate document-heavy workflows using Azure AI Document Intelligence and GPT-4 — intelligent extraction, classification, and end-to-end process automation.",
  ],
  [
    "AI Strategy & Architecture",
    "We help companies define their AI roadmap, evaluate LLM providers, design robust system architectures, and de-risk the path to production.",
  ],
];

export const STATS = [
  ["7+", "Years of production ML"],
  ["5+", "Cloud certifications"],
  ["3", "Cloud platforms — AWS · Azure · GCP"],
  ["10+", "Projects shipped"],
];

export const STACK = [
  "Python", "Databricks", "Apache Spark", "dbt", "AWS", "Azure", "GCP",
  "Terraform", "Kubernetes", "Docker", "Anthropic Claude", "Pinecone",
  "Apache Airflow", "MongoDB", "GitHub Actions", "OpenShift",
];

export const PAIN = [
  {
    t: "Stalled AI pilots",
    b: "Promising prototypes never reach production. Models work in notebooks but break the moment real users arrive.",
    icon: "stall",
  },
  {
    t: "No production ML in‑house",
    b: "Your team can ship features but has never run a live model. Hiring senior MLEs takes 9 months and breaks budgets.",
    icon: "team",
  },
  {
    t: "Cloud spend without discipline",
    b: "Idle GPUs, runaway pipelines, no observability. Bills grow faster than the model's accuracy.",
    icon: "burn",
  },
];

// PLACEHOLDER — no real client relationships confirmed yet.
export const LOGO_CLIENTS = [
  "MERIDIAN", "SOLARIS LABS", "ATLAS GAMING", "VEGA INSURANCE", "ORBIT SaaS", "NORTHWIND ENERGY",
];

// PLACEHOLDER — no partner certifications confirmed yet.
export const CERTS = [
  { t: "AWS Advanced Partner", s: "5 certified architects" },
  { t: "Microsoft Azure Partner", s: "Solutions Expert · Data" },
  { t: "Google Cloud Partner", s: "Professional ML Engineer" },
  { t: "Databricks Champion", s: "Lakehouse Specialty" },
];

export const ARCH_BOXES = [
  { x: 60, y: 80, w: 180, h: 60, t: "Streaming · Kafka", sub: "Real-time events" },
  { x: 60, y: 160, w: 180, h: 60, t: "Batch · Airflow", sub: "Scheduled ETL" },
  { x: 60, y: 240, w: 180, h: 60, t: "APIs · REST/gRPC", sub: "External sources" },
  { x: 360, y: 120, w: 180, h: 60, t: "Delta Lake", sub: "Bronze · Silver · Gold" },
  { x: 360, y: 200, w: 180, h: 60, t: "Vector DB · Pinecone", sub: "Embeddings" },
  { x: 660, y: 80, w: 180, h: 60, t: "Databricks Jobs", sub: "Training pipelines" },
  { x: 660, y: 160, w: 180, h: 60, t: "MLflow Registry", sub: "Model versions" },
  { x: 660, y: 240, w: 180, h: 60, t: "Eval Harness", sub: "Drift + quality" },
  { x: 960, y: 120, w: 180, h: 60, t: "LLM Gateway", sub: "Claude · OpenAI · OSS" },
  { x: 960, y: 200, w: 180, h: 60, t: "FastAPI · K8s", sub: "Production endpoints" },
];

export const STEPS = [
  { n: "01", t: "Discovery call", b: "30-min scoping. We listen, you describe the goal, the data, the constraints." },
  { n: "02", t: "Architecture review", b: "We audit your existing systems and produce a one-page target architecture." },
  { n: "03", t: "Statement of work", b: "Fixed milestones, fixed price or T&M, clear success criteria. No surprises." },
  { n: "04", t: "Sprint kickoff", b: "Two-week iterations, demo every Friday. Code in your repos from day one." },
  { n: "05", t: "Production handoff", b: "Runbooks, observability, knowledge transfer. We leave you self-sufficient." },
];

// PLACEHOLDER — anonymized/illustrative case studies, not verified client engagements.
export const CASES = [
  {
    tag: "INSURANCE",
    title: "Underwriting copilot",
    metric: "40% faster claim processing",
    body: "Built an LLM-driven document extraction pipeline on Azure AI + GPT-4. Handles 12k policies/day with 99.4% extraction accuracy and full audit trails.",
    stack: ["Azure AI", "GPT-4", "Databricks", "Terraform"],
    art: "doc",
  },
  {
    tag: "GAMING",
    title: "Real-time player analytics",
    metric: "8B events/month, sub-second",
    body: "Designed a Delta Lake architecture on Databricks with streaming ingest from Kafka. Powers in-game personalization for a top-10 mobile title.",
    stack: ["Databricks", "Kafka", "Delta", "MLflow"],
    art: "stream",
  },
  {
    tag: "ENTERPRISE SaaS",
    title: "Agentic support automation",
    metric: "62% ticket deflection",
    body: "Multi-agent system orchestrated via MCP — Claude routes tickets, retrieves from a Pinecone vector store, and writes back to Zendesk autonomously.",
    stack: ["Claude", "Pinecone", "MCP", "FastAPI"],
    art: "agent",
  },
];

// PLACEHOLDER — illustrative quotes, not verified client testimonials.
export const QUOTES = [
  {
    q: "They came in, audited our pipeline, and shipped a working RAG system in eight weeks. We've tripled query volume since with no degradation.",
    n: "M. Reyes",
    r: "VP Engineering · Vega Insurance",
  },
  {
    q: "Most consultants hand you a deck. Punta hands you the repo, the runbook, and a Slack channel. Our team learned more in one quarter than the previous year.",
    n: "L. Tanaka",
    r: "CTO · Atlas Gaming",
  },
  {
    q: "The architecture they proposed cut our Databricks bill by 38% in the first month. The migration was painless and the ROI was immediate.",
    n: "S. Bauer",
    r: "Head of Data · Orbit SaaS",
  },
];

export const LEAD_STEPS = [
  ["1", "Intro call (30 min)", "We listen, you describe the goal."],
  ["2", "Discovery workshop (1 day)", "We map data, systems, and unknowns."],
  ["3", "Project planning", "Statement of work, milestones, kickoff date."],
];

export const BUDGET_OPTIONS = ["< $50k", "$50–150k", "$150–500k", "$500k+"];

export const FAQS = {
  General: [
    ["How do you typically engage?", "Either project-based with a fixed scope, or as an embedded team running with your engineers for a quarter or two. Both kinds of engagement start with a discovery call."],
    ["Where are you based and where do you work?", "We're based in Madrid and operate globally. Most of our work is remote with a kickoff workshop on-site, plus quarterly visits for longer engagements."],
    ["What size projects do you take on?", "Engagements range from focused 4-week assessments to multi-quarter platform builds. Below $50k we usually point you to a different partner."],
  ],
  Technical: [
    ["Can we keep ownership of the code?", "Yes — code is committed directly to your repos from day one. You own everything. We don't keep proprietary forks."],
    ["Which clouds and stacks do you support?", "AWS, Azure, GCP for cloud. Databricks, Spark, dbt for data. Claude, OpenAI, and OSS models for LLM workloads. We're stack-pragmatic, not stack-loyal."],
    ["Do you provide ongoing maintenance?", "Optional — typically a retainer covering on-call, model retraining, and incremental features. Most clients move to self-sufficiency within 2 quarters."],
  ],
  Commercial: [
    ["How is pricing structured?", "Fixed-price per milestone for scoped work, or weekly rate for embedded teams. We never bill by the hour — it incentivizes the wrong things."],
    ["What are payment terms?", "30% on kickoff, milestone-based the rest, net-15 invoicing. We're flexible for repeat clients."],
    ["Do you sign NDAs and DPAs?", "Standard practice. We're GDPR-compliant and have signed agreements with companies under SOC 2 and HIPAA regimes."],
  ],
};
